// SVG health ring used in Customer detail panel
export default function HealthRing({ score }) {
  const color = score >= 85 ? 'var(--teal)' : score >= 70 ? 'var(--amber)' : 'var(--rose)';
  const r = 28, cx = 34, cy = 34;
  const circ = 2 * Math.PI * r;
  const offset = circ * (1 - score / 100);
  return (
    <div className="ring-wrap">
      <svg width="68" height="68">
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--s3)" strokeWidth="6" />
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke={color}
          strokeWidth="6"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${cx} ${cy})`}
        />
        <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central"
          fill={color} fontSize="14" fontWeight="800">{score}</text>
      </svg>
    </div>
  );
}
